import React from 'react';
import { BorrowerSellerSummary } from './BorrowerSellerSummary';
import { FilteredPartiesSummary } from './FilteredPartiesSummary';
import { LenderClientContainer } from './LenderClientContainer';
import { PartyModalsContainer } from './modals/PartyModalsContainer';

export const PartiesTab: React.FC = () => {
  return (
    <>
      <PartyModalsContainer />
      <BorrowerSellerSummary />
      <LenderClientContainer />
      <FilteredPartiesSummary />
    </>
  );
};
